import React from "react";
import PropTypes from 'prop-types';
import { Mail } from "react-feather";
import ImageWithBasePath from "../../../core/img/imagewithbasebath";
import variables from "../../../style/scss/utils/_variables.scss";
import AvatarUpload from "../fileUpload/AvatarUpload";

const FormInvoiceConf = ({ settings }) => {
    return (
        <div className="card p-4 row">
            <h4>Logo</h4>
            <div className="col-lg-2 col-sm-12 col-12 d-flex justify-content-center mb-3">
                <AvatarUpload
                    prefix="logo_recibo"
                    imageGrouperId="imagenes"
                    userId={`1`}
                    avatarPath={settings?.logo_url}
                    showUploadButton={false}
                />
            </div>
            <div className="col-lg-12 col-sm-12 col-12 mb-3">
                <label className="form-label">Nombre</label>
                <input type="text" className="form-control" value={settings?.name} disabled />
            </div>
            <div className="col-lg-12 col-sm-12 col-12 mb-3">
                <label className="form-label">Dirección</label>
                <input type="text" className="form-control" value={settings?.address} disabled />
            </div>
            <div className="col-lg-12 col-sm-12 col-12 mb-3">
                <label className="form-label">Correo electrónico</label>
                <div className="input-group flex-wrap">
                    <span className="input-group-text"><Mail size={15} color={variables.primaryColor} /></span>
                    <input
                        type="text"
                        className="form-control"
                        value={settings?.email}
                        disabled
                        maxLength={300}
                    />
                </div>
            </div>
            <div className="col-lg-12 col-sm-12 col-12 mb-3">
                <label className="form-label">Teléfono</label>
                <div className="input-group flex-wrap">
                    <ImageWithBasePath
                        src="assets/img/flags/mx.png"
                        alt="img"
                        id="mx"
                        style={{ height: 41 }}
                        className={"input-group-text"}
                    />
                    <span className="input-group-text">+52</span>
                    <input
                        type="text"
                        className="form-control"
                        value={settings?.phone}
                        maxLength={10}
                        disabled
                    />
                </div>
            </div>
            <div className="col-lg-12 col-sm-12 col-12 mb-3">
                <label className="form-label">Mensaje</label>
                <textarea
                    maxLength={60}
                    rows={3}
                    className="form-control"
                    value={settings?.message}
                    disabled
                />
                <p>Máximo 60 caracteres</p>
            </div>
        </div>
    );
};

FormInvoiceConf.propTypes = {
    settings: PropTypes.object.isRequired
};

export default FormInvoiceConf;
